import is from 'is_js';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useStorage } from './use-storage';
import { useSwal } from './use-swal';

function useErrorHandler() {
  const storage = useStorage();
  const { swal } = useSwal({ storage });
  const { t } = useTranslation();

  function handleError(error, handleGeneric, callback = () => {}) {
    const message = parseErrorMessage(
      error,
      handleGeneric
      // error.handleGeneric ?? handleGeneric
    );

    if (message != null) {
      callback(message);
    }
  }

  function parseErrorMessage(error, handleGeneric = true) {
    if (is.not.online()) {
      return t('error.no-internet');
    }

    let message = parseValidationMessage(error);

    if (message != null) {
      return message;
    }

    if (!handleGeneric) {
      message = error.message ?? error.description;
      return message;
    }

    if (handleGeneric) {
      return t('error.try-again');
    }

    return null;
  }

  function parseValidationMessage(error) {
    if (error?.response?.status === 422 && _.isArray(error?.response?.data)) {
      const validation = error?.response?.data?.find(() => true);
      return validation.message;
    }

    return null;
  }

  function handleErrorOnModal(error, handleGeneric = true) {
    handleError(error, handleGeneric, (message) => {
      if (swal.isVisible()) {
        swal.showValidationMessage(message);

        console.error(error);
      } else {
        throw error;
      }
    });
  }

  function throwNewValidationError(message) {
    const error = new Error();

    error.response = {
      status: 422,
      data: [
        {
          message,
        },
      ],
    };

    throw error;
  }

  return {
    handleError,
    handleErrorOnModal,
    parseValidationMessage,
    parseErrorMessage,
    throwNewValidationError,
  };
}

export { useErrorHandler };
